import React from 'react';
import { LiveRegionBlock } from "./LiveRegionBlock";
import { LiveRegionRole } from "./interfaces";
import { jsx as ___EmotionJSX } from "@emotion/core";

var Announcer = function Announcer(_ref) {
  var politeLogRegion = _ref.politeLogRegion,
      politeStatusRegion = _ref.politeStatusRegion,
      assertiveLogRegion = _ref.assertiveLogRegion,
      assertiveStatusRegion = _ref.assertiveStatusRegion;
  return ___EmotionJSX("div", null, ___EmotionJSX(LiveRegionBlock, {
    "aria-live": "assertive",
    role: LiveRegionRole.Status
  }, assertiveStatusRegion), ___EmotionJSX(LiveRegionBlock, {
    "aria-live": "assertive",
    role: LiveRegionRole.Log
  }, assertiveLogRegion), ___EmotionJSX(LiveRegionBlock, {
    "aria-live": "polite",
    role: LiveRegionRole.Status
  }, politeStatusRegion), ___EmotionJSX(LiveRegionBlock, {
    "aria-live": "polite",
    role: LiveRegionRole.Log
  }, politeLogRegion));
};

export default Announcer;